'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ = require('lodash');
var externalRegx = /^(http|https):\/\/(.*)/;
var mailtoRegx = /^mailto:([^\?]*)(?:\?subject=(.*)?)?/;
var pageRegx = /^\/([^ \?]*)[\?]?(.*)/;
var pageTopRegx = /^(\/?)([^ \?]*)#(top|SCROLL_TO_TOP)[\?]?(.*)/;
var pageBottomRegx = /^(\/?)([^ \?]*)#(bottom|SCROLL_TO_BOTTOM)[\?]?(.*)/;
var oldDocumentFormatRegx = /^document:\/\/(.*)/;
var newDocumentFormatRegx = /^wix:document:\/\/v1\/(.+)\/(.+)/;
var phoneRegx = /^tel:(.*)/;
var pageWithAnchor = /^\/([^ \?]*)#([^ \?]*)[\?]?(.*)/;
var samePageWithAnchor = /^#([^ \?]*)[\?]?(.*)/;
var ANCHOR_TYPE_TO_NAME = {
  SCROLL_TO_TOP: 'top',
  SCROLL_TO_BOTTOM: 'bottom'
};
var LinkType = {
  PAGE: 'PageLink',
  DYNAMIC_PAGE: 'DynamicPageLink',
  DYNAMIC_PAGE_WITH_QUERY_PARAMS: 'DynamicPageLinkWithQueryParams',
  EXTERNAL: 'ExternalLink',
  EMAIL: 'EmailLink',
  DOCUMENT: 'DocumentLink',
  PHONE: 'PhoneLink',
  PAGE_TOP: 'AnchorLink',
  PAGE_BOTTOM: 'AnchorLink',
  SAME_PAGE_ANCHOR_LINK: 'SamePageAnchorLink',
  ANCHOR: 'AnchorLink'
};

var SUPPORTED_TARGETS = ['_blank', '_self'];

var MASTER_PAGE_ID = 'masterPage';

var anchorLinkBaseTemplate = _.template('<%=linkObject.pageId%>#<%=linkObject.anchorDataId%>', { variable: 'linkObject' });
var pageLinkBaseTemplate = _.template('/<%=linkObject.pageId%>', { variable: 'linkObject' });

var UnsupportedLinkTypeError = function (_Error) {
  _inherits(UnsupportedLinkTypeError, _Error);

  function UnsupportedLinkTypeError() {
    _classCallCheck(this, UnsupportedLinkTypeError);

    var _this = _possibleConstructorReturn(this, (UnsupportedLinkTypeError.__proto__ || Object.getPrototypeOf(UnsupportedLinkTypeError)).call(this, 'Unsupported link type'));

    _this.name = 'UnsupportedLinkTypeError';

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, UnsupportedLinkTypeError);
    }
    return _this;
  }

  return UnsupportedLinkTypeError;
}(Error);

var UnsupportedTargetValueError = function (_Error2) {
  _inherits(UnsupportedTargetValueError, _Error2);

  function UnsupportedTargetValueError() {
    _classCallCheck(this, UnsupportedTargetValueError);

    var _this2 = _possibleConstructorReturn(this, (UnsupportedTargetValueError.__proto__ || Object.getPrototypeOf(UnsupportedTargetValueError)).call(this, 'Unsupported target value'));

    _this2.name = 'UnsupportedTargetValueError';
    _this2.supportedTargets = SUPPORTED_TARGETS;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this2, UnsupportedTargetValueError);
    }
    return _this2;
  }

  return UnsupportedTargetValueError;
}(Error);

function getInnerRoute(parts, hasAnchor, hasQueryParams) {
  var partsWithoutQueryParams = parts;
  if (hasQueryParams) {
    partsWithoutQueryParams = _.dropRight(parts);
  }
  var partsWithoutPrefixAndSuffix = _.drop(hasAnchor ? _.dropRight(partsWithoutQueryParams) : partsWithoutQueryParams);
  return _.join(partsWithoutPrefixAndSuffix, '/');
}

var LINK_URL_TEMPLATES = {
  PageLink: {
    url: getPageLinkTemplate, link: function link(type, parts, siteStructurePrefixes, siteStructurePages) {
      var pageLinkObj = {
        type: type,
        pageId: '#' + translateUriSeoToPageId(parts[1], siteStructurePages)

      };
      if (parts.length === 3 && parts[2]) {
        _.assign(pageLinkObj, { queryParams: convertQueryParamsToObject(parts[2]) || '' });
      }
      return pageLinkObj;
    },
    regex: [pageRegx]
  },
  DocumentLink: {
    url: _.template('wix:document://v1/<%=linkObject.docId%>/<%=linkObject.name%>', { variable: 'linkObject' }), link: function link(type, parts) {
      return {
        type: type,
        docId: parts[1],
        name: _.isUndefined(parts[2]) ? '' : parts[2]
      };
    },
    regex: [oldDocumentFormatRegx, newDocumentFormatRegx]
  },
  PhoneLink: {
    url: _.template('tel:<%=linkObject.phoneNumber%>', { variable: 'linkObject' }), link: function link(type, parts) {
      return {
        type: type,
        phoneNumber: parts[1]
      };
    },
    regex: [phoneRegx]
  },
  EmailLink: {
    url: getEmailLinkTemplate,
    link: function link(type, parts) {
      var data = {
        type: type,
        recipient: _.escape(parts[1])
      };
      if (parts[2]) {
        data.subject = _.escape(parts[2]);
      }
      return data;
    },

    regex: [mailtoRegx]
  },
  ExternalLink: {
    url: _.template('<%=linkObject.url%>', { variable: 'linkObject' }), link: function link(type, parts, siteStructurePrefixes, siteStructurePages, target) {
      if (target && !_.includes(SUPPORTED_TARGETS, target)) {
        throw new UnsupportedTargetValueError();
      }
      return {
        type: type,
        url: _.template('<%= partA %>://<%= partB%>')({ partA: parts[1], partB: parts[2] }),
        target: target || '_blank'
      };
    },
    regex: [externalRegx]
  },
  DynamicPageLink: {
    url: getDynamicPageLinkTemplate, link: function link(type, parts, siteStructurePrefixes) {
      var hasAnchor = _.startsWith(_.last(parts), '#');
      var routerData = _.find(siteStructurePrefixes, { name: parts[0] });
      var data = {
        type: type,
        innerRoute: getInnerRoute(parts, hasAnchor) || '/',
        routerId: routerData.id
      };
      if (hasAnchor) {
        var anchorName = _.last(parts).replace('#', '');
        data.anchorDataId = _.get(_.invert(ANCHOR_TYPE_TO_NAME), anchorName, anchorName);
      }
      return data;
    },
    regex: [pageTopRegx, pageBottomRegx, pageWithAnchor, pageRegx]
  },
  DynamicPageLinkWithQueryParams: {
    url: getDynamicPageLinkTemplate, link: function link(type, parts, siteStructurePrefixes) {
      var queryParams = _.last(parts);
      var hasAnchor = _.startsWith(parts[parts.length - 2], '#');
      var routerData = _.find(siteStructurePrefixes, { name: parts[0] });
      var data = {
        type: LinkType.DYNAMIC_PAGE,
        innerRoute: getInnerRoute(parts, hasAnchor, true) || '/',
        routerId: routerData.id,
        queryParams: convertQueryParamsToObject(queryParams)

      };
      if (hasAnchor) {
        var anchorName = parts[parts.length - 2].replace('#', '');
        data.anchorDataId = _.get(_.invert(ANCHOR_TYPE_TO_NAME), anchorName, anchorName);
      }
      return data;
    },
    regex: [pageTopRegx, pageBottomRegx, pageWithAnchor, pageRegx]
  },
  AnchorLink: {
    url: getAnchorLinkTemplate, link: function link(type, parts, siteStructurePrefixes, pages) {
      var anchorDataId = parts[2];
      var anchorLinkObj = {
        type: type,
        pageId: '#' + translateUriSeoToPageId(parts[1], pages),
        anchorDataId: _.invert(ANCHOR_TYPE_TO_NAME)[anchorDataId] || anchorDataId
      };
      if (parts.length === 4 && parts[3]) {
        _.assign(anchorLinkObj, { queryParams: convertQueryParamsToObject(parts[3]) });
      }
      return anchorLinkObj;
    },
    regex: [pageWithAnchor]
  },
  SamePageAnchorLink: {
    url: getAnchorLinkTemplate, link: function link(type, parts) {
      var anchorDataId = parts[1];
      var samePageAnchorLinkObj = {
        type: LinkType.ANCHOR,
        anchorDataId: _.invert(ANCHOR_TYPE_TO_NAME)[anchorDataId] || anchorDataId,
        pageId: '#' + MASTER_PAGE_ID
      };
      if (parts.length === 3 && parts[2]) {
        _.assign(samePageAnchorLinkObj, { queryParams: convertQueryParamsToObject(parts[2]) });
      }
      return samePageAnchorLinkObj;
    },
    regex: [samePageWithAnchor]
  }
};

function getUrlParts(regExpArr, value, type) {
  if (type === LinkType.DYNAMIC_PAGE || type === LinkType.DYNAMIC_PAGE_WITH_QUERY_PARAMS) {
    return getDynamicPageParts(value);
  }
  var regexp = _.find(regExpArr, function (regExpItem) {
    return regExpItem.test(value);
  });
  var parts = value.match(regexp);
  parts = parts ? parts : [];
  return parts;
}

function getDynamicPageParts(str) {
  var pageRegRes = str.match(pageRegx);
  var parts = pageRegRes[1].replace('#', '/#').split(/[\/]+/);
  var hasQueryParam = _.includes(str, '?');
  if (hasQueryParam) {
    parts.push(_.last(pageRegRes));
  }
  return parts;
}

function getAnchorName(anchorDataId) {
  return ANCHOR_TYPE_TO_NAME[anchorDataId] || anchorDataId;
}

function getDynamicPagePrefix(siteStructurePrefixes, linkObject) {
  var routerConfig = _.find(siteStructurePrefixes, { id: linkObject.routerId });
  return routerConfig && routerConfig.prefix;
}

function getDynamicPageLinkTemplate(linkObject, siteStructurePrefixes) {
  var dynamicPageSuffix = !linkObject.innerRoute || linkObject.innerRoute === '/' ? '' : '/' + linkObject.innerRoute;
  var route = getDynamicPagePrefix(siteStructurePrefixes, linkObject) + dynamicPageSuffix;

  var anchorDataId = getAnchorName(linkObject.anchorDataId);
  var customLinkObject = {
    pageId: _.startsWith(route, '/') ? route : '/' + route,
    anchorDataId: anchorDataId
  };
  return customLinkObject.anchorDataId ? anchorLinkBaseTemplate(customLinkObject) : route;
}

function getPageLinkTemplate(linkObject, siteStructurePrefixes, siteStructurePages) {
  var pageId = getPageIdForURL(linkObject.pageId);
  var pageObj = _.find(siteStructurePages, { id: pageId });
  return pageObj ? pageObj.url : pageLinkBaseTemplate({ pageId: pageId });
}

function getEmailLinkTemplate(linkObject) {
  var templateString = 'mailto:<%=linkObject.recipient%>';
  if (_.has(linkObject, 'subject')) {
    templateString += '?subject=<%=linkObject.subject%>';
  }

  return _.template(templateString, { variable: 'linkObject' })(linkObject);
}

function getAnchorLinkTemplate(linkObject, siteStructurePrefixes, siteStructurePages) {
  var anchorName = getAnchorName(linkObject.anchorDataId);
  if (isMasterPage(extractPageId(linkObject.pageId))) {
    return '#' + anchorName;
  }

  var pageId = getPageIdForURL(linkObject.pageId);
  var pageObj = _.find(siteStructurePages, { id: pageId });
  return pageObj ? anchorLinkBaseTemplate({
    pageId: pageObj.url,
    anchorDataId: anchorName
  }) : anchorLinkBaseTemplate({
    pageId: _.startsWith(pageId, '/') ? pageId : '/' + pageId,
    anchorDataId: anchorName
  });
}

function getPageIdForURL(pageId) {
  pageId = extractPageId(pageId);
  if (isMasterPage(pageId)) {
    return '';
  }

  return pageId.replace('#', '');
}

function extractPageId(pageId) {
  if (!pageId) {
    return pageId;
  }

  if (_.isPlainObject(pageId)) {
    if (pageId.pageUriSEO) {
      return pageId.pageUriSEO;
    } else if (isMasterPage(pageId.id)) {
      return MASTER_PAGE_ID;
    }

    throw new Error('pageId object should contain pageUriSEO');
  }

  return pageId;
}

function translateUriSeoToPageId(uriSeo, siteStructurePages) {
  var isHomePage = uriSeo === '';
  var pageData = isHomePage ? _.find(siteStructurePages, 'isMainPage') : _.find(siteStructurePages, { url: '/' + uriSeo });
  return _.get(pageData, 'id', uriSeo);
}

function isDynamicPage(urlParts, siteStructurePrefixes) {
  return _.find(siteStructurePrefixes, { name: urlParts[0] });
}

function getDynamicPageType(str) {
  return _.includes(str, '?') ? LinkType.DYNAMIC_PAGE_WITH_QUERY_PARAMS : LinkType.DYNAMIC_PAGE;
}

function isMasterPage(pageId) {
  return pageId.replace('#', '') === MASTER_PAGE_ID;
}

function getLinkType(str, siteStructurePrefixes) {
  switch (true) {
    case externalRegx.test(str):
      return LinkType.EXTERNAL;
    case mailtoRegx.test(str):
      return LinkType.EMAIL;
    case samePageWithAnchor.test(str):
      return LinkType.SAME_PAGE_ANCHOR_LINK;
    case pageTopRegx.test(str):
      return isDynamicPage(getDynamicPageParts(str), siteStructurePrefixes) ? getDynamicPageType(str) : LinkType.PAGE_TOP;
    case pageBottomRegx.test(str):
      return isDynamicPage(getDynamicPageParts(str), siteStructurePrefixes) ? getDynamicPageType(str) : LinkType.PAGE_BOTTOM;
    case pageWithAnchor.test(str):
      return isDynamicPage(getDynamicPageParts(str), siteStructurePrefixes) ? getDynamicPageType(str) : LinkType.ANCHOR;
    case pageRegx.test(str):
      return isDynamicPage(getDynamicPageParts(str), siteStructurePrefixes) ? getDynamicPageType(str) : LinkType.PAGE;
    case oldDocumentFormatRegx.test(str):
      return LinkType.DOCUMENT;
    case newDocumentFormatRegx.test(str):
      return LinkType.DOCUMENT;
    case phoneRegx.test(str):
      return LinkType.PHONE;
    default:
      throw new UnsupportedLinkTypeError();
  }
}

function convertLinkObjectToUrl(siteStructurePrefixes, linkObject, siteStructurePages) {
  if (!linkObject || !_.get(LINK_URL_TEMPLATES, [linkObject.type, 'url'])) {
    throw new Error('Provided link type is not supported');
  }
  var urlTemplate = _.get(LINK_URL_TEMPLATES, [linkObject.type, 'url']);
  return urlTemplate(linkObject, siteStructurePrefixes, siteStructurePages);
}

function convertUrlToLinkObject(siteStructurePrefixes, url, target, siteStructurePages) {
  var type = getLinkType(url, siteStructurePrefixes);
  var urlParts = getUrlParts(LINK_URL_TEMPLATES[type].regex, url, type);
  var linkTemplate = _.get(LINK_URL_TEMPLATES, [type, 'link']);
  return linkTemplate(type, urlParts, siteStructurePrefixes, siteStructurePages, target);
}

function getAnchorDataId(linkItem) {
  return getAnchorName(linkItem.anchorDataId);
}

function getPageId(linkItem) {
  return extractPageId(linkItem.pageId);
}

function convertQueryParamsToObject(query) {
  if (!_.isString(query)) {
    return {};
  }
  var queryStringArray = query.split('&');
  return _.reduce(queryStringArray, function (res, queryParam) {
    var splitedQueryParam = queryParam.split("=");
    res[splitedQueryParam[0]] = splitedQueryParam[1] ? decodeURIComponent(splitedQueryParam[1]) : null;
    return res;
  }, {});
};

module.exports = {
  convertLinkObjectToUrl: convertLinkObjectToUrl,
  convertUrlToLinkObject: convertUrlToLinkObject,
  getAnchorDataId: getAnchorDataId,
  getPageId: getPageId,
  convertQueryParamsToObject: convertQueryParamsToObject
};


// WEBPACK FOOTER //
// ./~/santa-platform-utils/lib/linkUtils.js